import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { AutoComplete, Button, Col, DatePicker, Form, Icon, Input, notification, Radio, Row, Spin } from 'antd';
import moment from 'moment';
import _ from 'lodash';

import * as channelController from '../../../../../../services/api/channel';
import './ChannelForm.scss';

const FormItem = Form.Item;
const Option = AutoComplete.Option;
const RadioGroup = Radio.Group;

export class ChannelForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            channelSources: [],
            channelTypes: []
        };

        this.startDateValidator = this.startDateValidator.bind(this);
    }

    fetchChannelSource() {
        channelController.getChannelSources()
            .then((res) => res.json())
            .then((json) => this.setState({ channelSources: json }))
    }

    fetchChannelType() {
        channelController.getChannelTypes()
            .then((res) => res.json())
            .then((json) => this.setState({ channelTypes: json }))
    }

    startDateValidator(rule, value, cb) {
        const { form } = this.props;
        const endDate = form.getFieldValue('end_date');

        return (!endDate || !value || value.isBefore(endDate)) ? cb() : cb(true);
    }

    endDateValidator(rule, value, cb) {
        const { form } = this.props;
        const startDate = form.getFieldValue('start_date');

        return (!startDate || !value || value.isAfter(startDate)) ? cb() : cb(true);
    }

    handleChannelSourceDelete(sourceId, e) {
        e.stopPropagation();

        channelController.deleteChannelSource(sourceId)
            .then((res) => res.json)
            .then((json) => this.fetchChannelSource())
    }

    handleChannelTypeDelete(typeId, e) {
        e.stopPropagation();

        channelController.deleteChannelType(typeId)
            .then((res) => res.json)
            .then((json) => this.fetchChannelType())
    }

    handleSubmit(e) {
        const { history, match, form } = this.props;
        const { channelSources, channelTypes } = this.state;
        const channelId = match.params.channelId;
        const isCreateNewChannel = match.params.channelId === undefined;

        e.preventDefault();
        this.setState({ isLoading: true });

        form.validateFields((err, values) => {
            if (!err) {
                const { name, type, source, is_active, start_date, end_date } = values;
                const targetChannelSource = _.find(channelSources, { name: source });
                const targetChannelType = _.find(channelTypes, { name: type });

                let body = { name, is_active, start_date, end_date };
                if (_.isEmpty(targetChannelSource))
                    body.source = { name: source };
                else
                    body.source_id = targetChannelSource.id;

                if (_.isEmpty(targetChannelType))
                    body.type = { name: type };
                else
                    body.type_id = targetChannelType.id;

                (isCreateNewChannel ? channelController.createChannel(body) : channelController.updateChannel(channelId, body))
                .then((res) => res.json())
                    .then((json) => {
                        this.setState({ isLoading: false });
                        history.push('/dashboard/admin/channel');
                    })
                    .catch((err) => {
                        notification.error({
                            message: 'Unexpected Error',
                            description: 'Please report this issue to engineer.',
                            duration: 0
                        });
                        this.setState({ isLoading: false });
                    })
            } else {
                this.setState({ isLoading: false });
            }
        });
    }

    componentDidMount() {
        const { match, form } = this.props;
        const channelId = match.params.channelId;
        let promises = [];
        promises.push(this.fetchChannelSource());

        promises.push(this.fetchChannelType());

        if (channelId === undefined) {
            form.resetFields();
        } else {
            this.setState({ isLoading: true });
            promises.push(
                channelController.getChannel(channelId)
                .then((res) => res.json())
                .then((json) => {
                    const { name, type, source, is_active, start_date, end_date } = json;
                    form.setFieldsValue({
                        name,
                        type: type ? type.name : '',
                        source: source ? source.name : '',
                        is_active,
                        start_date: moment(start_date),
                        end_date: moment(end_date)
                    });
                }));
        }

        Promise.all(promises)
            .then(() => this.setState({ isLoading: false }));
    }

    render() {
        const { history, match, form } = this.props;
        const { isLoading, channelSources, channelTypes } = this.state;
        const { getFieldDecorator } = form;
        const isCreateNewChannel = match.params.channelId === undefined;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const sourceOptions = _.map(channelSources, (channelSource) => (
            <Option 
                key={channelSource.name} 
                value={channelSource.name}
            >
                {channelSource.name}
                <div className="option-delete-btn" onClick={(e) => this.handleChannelSourceDelete(channelSource.id, e)}>
                    <Icon type="close" />
                </div>
            </Option>
        ))
        const typeOptions = _.map(channelTypes, (channelType) => (
            <Option 
                key={channelType.name} 
                value={channelType.name}
            >
                {channelType.name}
                <div className="option-delete-btn" onClick={(e) => this.handleChannelTypeDelete(channelType.id, e)}>
                    <Icon type="close" />
                </div>
            </Option>
        ))

        return (
            <Spin spinning={isLoading}>          
                <Form className="ChannelForm" onSubmit={(e) => this.handleSubmit(e)}>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Channel Name">
                                {
                                    getFieldDecorator('name', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                    })(
                                        <Input placeholder="Input Channel Name" />
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Channel Type">
                                {
                                    getFieldDecorator('type', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                    })(
                                        <AutoComplete
                                            placeholder="Input or Select Channel Type"
                                            dataSource={typeOptions}
                                            optionLabelProp="value"
                                            filterOption={(inputValue, option) => option.props.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                                        />
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Channel Source">
                                {
                                    getFieldDecorator('source', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                    })(
                                        <AutoComplete
                                            placeholder="Input or Select Channel Source"
                                            dataSource={sourceOptions}
                                            optionLabelProp="value"
                                            filterOption={(inputValue, option) => option.props.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                                        />
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Active">
                                {
                                    getFieldDecorator('is_active', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                        initialValue: true
                                    })(
                                        <RadioGroup>
                                            <Radio value={true}>Yes</Radio>
                                            <Radio value={false}>No</Radio>
                                        </RadioGroup>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Start Date">
                                {
                                    getFieldDecorator('start_date', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }, {
                                            message: 'Start Date has to be earlier than End Date.',
                                            validator: (rule, value, cb) => this.startDateValidator(rule, value, cb),
                                        }],
                                    })(
                                        <DatePicker/>
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="End Date">
                                {
                                    getFieldDecorator('end_date', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }, {
                                            message: 'End Date has to be later than Start Date.',
                                            validator: (rule, value, cb) => this.endDateValidator(rule, value, cb),
                                        }],
                                    })(
                                        <DatePicker/>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <FormItem>
                            <Button onClick={(e) => history.push('/dashboard/admin/channel')}>Back</Button>
                            {' '}
                            <Button type="primary" htmlType="submit">{isCreateNewChannel ? 'Create' : 'Update'}</Button>
                        </FormItem>
                    </Row>
                </Form>
            </Spin>
        );
    }
}

const WrappedChannelForm = Form.create()(ChannelForm);
export default withRouter(WrappedChannelForm);


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ChannelManagementPage/components/ChannelForm/ChannelForm.js